export default __webpack_public_path__ + "static/media/correct.67c72208.svg";